<template>
  <v-container
    :style="containerStyle"
    class="object-info pa-0"
  >
    <MyLoader
      v-if="progressOpening"
      :style="{
        marginTop: '150px',
      }"
    />
    <v-row
      v-else
      class="pb-5"
      :style="isMobileView ? 'padding-bottom: 30px !important;' : ''"
      no-gutters
    >
      <template>
        <!-- IMAGES -->

        <v-col
          v-if="isMobileView"
          cols="12"
        >
          <ObjectImages
            :images="objectImagesComputed"
            :compact="isMobileView"
            :rooms="objectRoomsComputed"
            :img-folder="'objectImages/large'"
          />
        </v-col>

        <v-col
          :class="isMobileView ? 'px-4 pt-3' : 'pt-1'"
          cols="12"
        >
          <div
            v-if="!Object.keys($store.state.featuresList).length"
            style="height: 2000px"
          >
            &nbsp;
          </div>
          <v-container
            v-else
            class="py-0 px-0"
          >
            <v-row>
              <!-- TITLE -->

              <v-col
                :cols="isDesktopView ? 10 : 9"
                :class="(isMobileView ? 'px-2' : '') + ' pb-0'"
              >
                <h1
                  :class="isMobileView ? 'mobile-object-name' : ''"
                  style="float: left"
                >
                  {{ object.objectName }}
                </h1>
                <div
                  :style="
                    isMobileView ? 'clear: left;' : 'display: inline-block'
                  "
                  :class="isMobileView ? 'pt-2' : 'pt-2 pl-3'"
                >
                  <v-btn
                    class="elevation-0"
                    color="grey lighten-4"
                    small
                    @click="$store.dispatch('toggleFavorite', object)"
                  >
                    <v-icon
                      class="mr-2"
                      style="color: red"
                      small
                    >
                      {{ isFavorite(object) ? 'fa fa-heart' : 'far fa-heart' }}
                    </v-icon>
                    {{ $t('save_favorite') }}
                  </v-btn>

                  <v-btn
                    v-if="object.videoLink"
                    class="elevation-0 ml-3"
                    color="grey lighten-4"
                    small
                    @click="scrollToVideo"
                  >
                    <v-icon
                      class="mr-2"
                      style="color: #219bc8"
                      small
                    >
                      fa-video
                    </v-icon>
                    {{ $i18n.t('video') }}
                  </v-btn>

                  <v-menu
                    v-if="isDesktopView"
                    origin="top center"
                    transition="scale-transition"
                    offset-y
                    bottom
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="elevation-0 ml-3"
                        color="grey lighten-4"
                        small
                        v-on="on"
                      >
                        <v-icon
                          class="mr-2"
                          style="color: #219bc8"
                          small
                        >
                          fa-share
                        </v-icon>
                        {{ $i18n.t('jaga') }}
                      </v-btn>
                    </template>
                    <MainShare :absolute="true" />
                  </v-menu>
                </div>
              </v-col>

              <!-- CSR ID -->

              <v-col
                :cols="isDesktopView ? 2 : 3"
                :class="'pb-0 mobile-csr ' + (isMobileView ? 'px-2' : '')"
              >
                <b>{{ $i18n.t('csr_id') }}: {{ object.csrId }}</b>
              </v-col>

              <!-- ADDRESS & SHARE -->

              <template>
                <v-col
                  cols="12"
                  :class="isMobileView ? 'px-2' : 'pb-2'"
                  style="position: relative"
                >
                  <h3 class="mobile-object-address">{{ object.address }}</h3>
                </v-col>
              </template>

              <!-- DESKTOP ONLY -->

              <template v-if="isDesktopView">
                <!-- BACK BTN -->

                <v-col
                  cols="12"
                  :class="(isMobileView ? 'px-2 py-2' : 'py-2') + ' pb-0'"
                >
                  <v-btn
                    color="grey"
                    text
                    @click="goBack"
                  >
                    <v-icon
                      small
                      class="pr-2"
                    >
                      fa-arrow-left
                    </v-icon>
                    {{ $t('tagasi') }}
                  </v-btn>
                </v-col>
              </template>

              <v-col
                v-if="object['description_' + lang]"
                cols="12"
                ref="descriptionContainer"
                :class="' text-left pb-0  ' + (isMobileView ? 'px-2' : 'px-3')"
              >
                <div
                  :style="{
                    borderBottom: '1px solid #ddd',
                    width: '100%',
                  }"
                  class="pb-3"
                >
                  <div
                    ref="descriptionContent"
                    :style="{
                      maxHeight: descriptionHeight
                        ? descriptionHeight + 'px'
                        : '10000px',
                      height: descriptionHeight
                        ? descriptionHeight + 'px'
                        : 'auto',
                      minHeight: descriptionHeight
                        ? descriptionHeight + 'px'
                        : 'auto',
                    }"
                    :class="
                      'text-left ' +
                      (descriptionHeight ? 'desc-content-cut' : 'desc-content')
                    "
                    v-html="
                      object['description_' + lang].replaceAll(
                        descriptionHeight ? '<br>' : '',
                        ''
                      )
                    "
                  />
                  <v-btn
                    color="grey"
                    class="mt-1 ml-n4"
                    text
                    @click="toggleReadMore"
                  >
                    {{ descriptionHeight ? $t('show_more') : $t('show_less') }}
                    <v-icon
                      small
                      class="pl-2"
                    >
                      {{ descriptionHeight ? 'fa-angle-right' : 'fa-angle-up' }}
                    </v-icon>
                  </v-btn>
                </div>
              </v-col>

              <!-- FEATURES BY GROUP -->

              <v-col
                :class="
                  (isMobileView ? 'px-2' : '') +
                  ' pb-2 pt-0 object-info-feature'
                "
                cols="12"
                md="6"
              >
                <v-container
                  v-for="(featureGroup, fgIndex) in featureGroups.filter(
                    (fg) =>
                      fg.showOnObjectPage &&
                      (fg.id === '5bc978b1e07c9e232eca5699' || isDesktopView)
                  )"
                  :key="fgIndex"
                  :class="'px-0 pt-1 ' + (fgIndex > 0 ? 'bottom-top' : '')"
                >
                  <ObjectInfoFeaturesForGroup
                    :object="object"
                    :feature-group="featureGroup"
                  />
                </v-container>
              </v-col>

              <v-col
                cols="12"
                class="py-0"
                md="6"
              >
                <v-container
                  v-for="(room, rIndex) in objectRoomsComputed"
                  :key="rIndex"
                  :class="
                    'px-0 pt-1 ' +
                    (rIndex > 0 || isMobileView ? 'bottom-top' : '')
                  "
                >
                  <ObjectRoomFeatures
                    v-if="objectRoomTypesById[room.type]"
                    :room="room"
                    :title="objectRoomTypesById[room.type]['typeName_' + lang]"
                    :features-field="
                      featuresFieldToUse(
                        objectRoomTypesById[room.type].typeCode
                      )
                    "
                  />
                </v-container>
              </v-col>

              <v-col
                v-if="isMobileView"
                cols="12"
                class="py-0"
                md="6"
              >
                <v-container
                  v-for="(featureGroup, fgIndex) in featureGroups.filter(
                    (fg) =>
                      fg.showOnObjectPage &&
                      fg.id !== '5bc978b1e07c9e232eca5699'
                  )"
                  :key="fgIndex + '_2'"
                  class="px-0 pt-1 bottom-top"
                >
                  <ObjectInfoFeaturesForGroup
                    :object="object"
                    :index="fgIndex"
                    :feature-group="featureGroup"
                  />
                </v-container>
              </v-col>

              <!-- VIDEO -->

              <v-col
                v-if="object.videoLink"
                id="video"
                cols="12"
              >
                <div
                  style="
                    position: relative;
                    padding-bottom: 56.55%;
                    height: 0;
                    overflow: hidden;
                    border-radius: 8px;
                  "
                >
                  <iframe
                    style="
                      position: absolute;
                      top: -1px;
                      left: -1px;
                      width: 100.4%;
                      height: 100.4%;
                      border: 0;
                    "
                    :src="
                      'https://www.youtube-nocookie.com/embed/' +
                      object.videoLink.split('/').pop() +
                      '?rel=0&amp;controls=1&amp&amp;showinfo=0&amp;modestbranding=1'
                    "
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen
                    frameborder="0"
                  />
                </div>
              </v-col>

              <!-- PRICES -->

              <v-col class="py-0">
                <v-container
                  :class="
                    object.videoLink
                      ? 'px-0 pt-4 my-4'
                      : 'px-0 pt-4 bottom-top my-4'
                  "
                  style=""
                >
                  <v-row class="align-center justify-center">
                    <v-col
                      :cols="enableCollapsing ? 10 : 12"
                      :class="enableCollapsing ? 'py-2' : 'pt-3 pb-0'"
                      @click="togglePricesCollapsed"
                    >
                      <h3>{{ $t('prices') }}</h3>
                    </v-col>
                    <v-col
                      v-if="enableCollapsing"
                      cols="2"
                      class="feature-collapse-icon py-2 text-right"
                      @click="togglePricesCollapsed"
                    >
                      <v-icon small>{{
                        pricesCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'
                      }}</v-icon>
                    </v-col>

                    <v-col
                      v-if="!pricesCollapsed"
                      :class="enableCollapsing ? 'pb-2 pt-2' : ''"
                      cols="12"
                    >
                      <table
                        v-if="objectPricesComputed.length > 0"
                        :class="
                          'object-prices-table ' +
                          (isMobileView ? 'object-price-table-mobile' : '')
                        "
                      >
                        <tr>
                          <td
                            cols="2"
                            class="in-bold"
                          >
                            {{ $i18n.t('hooaeg') }}
                          </td>
                          <td
                            v-if="hasPeriodPrices('dayPrice')"
                            xs2
                            class="in-bold"
                          >
                            {{ $i18n.t('öö') }}
                            <template
                              v-if="
                                !mobile &&
                                objectPricesComputed &&
                                objectPricesComputed[0] &&
                                objectPricesComputed[0].minDays
                              "
                            >
                              ({{ $i18n.t('min') }}
                              {{ objectPricesComputed[0].minDays }}
                              {{ $i18n.t('ööd') }})
                            </template>
                          </td>
                          <td
                            v-if="hasPeriodPrices('weekPrice')"
                            cols="2"
                            class="in-bold"
                          >
                            {{ $i18n.t('week') }}
                          </td>
                          <td
                            v-if="hasPeriodPrices('twoWeekPrice')"
                            cols="2"
                            class="in-bold"
                          >
                            2 {{ $i18n.t('weeks') }}
                          </td>
                          <td
                            v-if="hasPeriodPrices('monthPrice')"
                            cols="4"
                            class="in-bold"
                          >
                            {{ $i18n.t('month') }}
                            <template
                              v-if="
                                !mobile &&
                                objectPricesComputed &&
                                objectPricesComputed[0] &&
                                objectPricesComputed[0].minMonths
                              "
                            >
                              ({{ $i18n.t('min') }}
                              {{ objectPricesComputed[0].minMonths }}
                              {{ $i18n.t('kuud') }})
                            </template>
                          </td>
                        </tr>
                        <tr
                          v-for="(price, priceIndex) in objectPricesComputed"
                          :key="priceIndex"
                        >
                          <td
                            cols="2"
                            :key="priceIndex + '_1'"
                          >
                            {{ price.dateStart }} -
                            {{ price.dateEnd }}
                          </td>
                          <td
                            v-if="hasPeriodPrices('dayPrice')"
                            xs2
                            :key="priceIndex + '_2'"
                          >
                            {{ price.dayPrice ? price.dayPrice + ' €' : null }}
                          </td>
                          <td
                            v-if="hasPeriodPrices('weekPrice')"
                            cols="2"
                            :key="priceIndex + '_3'"
                          >
                            {{
                              price.weekPrice ? price.weekPrice + ' €' : null
                            }}
                          </td>
                          <td
                            v-if="hasPeriodPrices('twoWeekPrice')"
                            cols="2"
                            :key="priceIndex + '_4'"
                          >
                            {{
                              price.twoWeekPrice
                                ? price.twoWeekPrice + ' €'
                                : null
                            }}
                          </td>
                          <td
                            v-if="hasPeriodPrices('monthPrice')"
                            cols="4"
                            :key="priceIndex + '_5'"
                          >
                            {{
                              price.monthPrice ? price.monthPrice + ' €' : null
                            }}
                          </td>
                        </tr>
                      </table>
                    </v-col>
                    <!-- v-col cols="12" v-if="enableCollapsing && pricesCollapsed">
                      <div style="border-bottom: 1px solid #ddd; height: 1px; width: 100%;"></div>
                    </v-col -->
                  </v-row>
                </v-container>
              </v-col>

              <v-col
                v-if="false"
                :class="isMobileView ? 'px-2' : ''"
                cols="12"
              >
                <div style="float: left">
                  <div
                    class="list-object-text object-properties-div"
                    style="float: left"
                    v-html="objectInfoShort"
                  ></div>
                  <div
                    class="list-object-text object-properties-div"
                    style="float: left; clear: both"
                    v-html="objectInfoExtended"
                  ></div>
                  <div v-html="object.properties" />
                </div>
              </v-col>
              <v-col
                v-if="object.touristPermit"
                cols="12"
                class="py-3 px-2"
              >
                <v-icon small>fa-certificate</v-icon>
                {{ $i18n.t('tourist_license') }}: {{ object.touristPermit }}
              </v-col>
              <v-col
                v-if="isMobileView"
                cols="12"
                class="px-2"
              >
                <ContactUsMenu :contact-options="contactOptions" />
              </v-col>

              <v-col
                v-if="isDesktopView"
                v-html="$i18n.t('object_info_contacts')"
                :class="isMobileView ? 'px-2 pt-3' : ''"
                cols="12"
                style="font-weight: 700; color: rgb(33, 154, 200)"
              >
              </v-col>

              <v-col
                v-if="object.calendar && isMobileView"
                cols="6"
                class="px-2 mt-3 pt-2"
                id="object-calendar"
              >
                <span style="font-size: 17px"
                  ><b>{{ $i18n.t('check_in') }}</b></span
                >
                <br />
                <template v-if="searchFilters.dateStart">
                  <span class="mobile-selected-date">{{
                    searchFilters.dateStart
                  }}</span>
                </template>
                <template v-else>
                  <span style="color: red">
                    {{ $i18n.t('select_date') }} &darr;
                  </span>
                </template>
              </v-col>
              <v-col
                v-if="object.calendar && isMobileView"
                cols="6"
                class="px-2 mt-3 pt-2"
              >
                <span style="font-size: 17px"
                  ><b>{{ $i18n.t('check_out') }}</b></span
                >
                <br />
                <template v-if="searchFilters.dateEnd">
                  <span class="mobile-selected-date">{{
                    searchFilters.dateEnd
                  }}</span>
                </template>
                <template v-else-if="searchFilters.dateStart">
                  <span style="color: red">
                    {{ $i18n.t('select_date') }} &darr;
                  </span>
                </template>
                <template v-else> - - - - - - - </template>
              </v-col>
              <v-col
                v-if="isMobileView"
                cols="12"
                class="px-2"
              >
                <CalendarNavigation :show-overlay="!object.calendar" />
                <CalendarNavigation
                  v-if="object.calendar"
                  :plus-months="1"
                  :show-overlay="!object.calendar"
                />
                <div
                  v-if="searchFilters.dateEnd || searchFilters.dateStart"
                  style="position: relative"
                  @click="clearSearch"
                >
                  <div style="position: absolute; top: 10px; right: 5px">
                    <a>{{ $i18n.t('clear_days') }}</a>
                  </div>
                </div>
                <calendar-legend />
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col
          cols="12"
          class="text-center px-3 pt-3"
        >
          <v-btn
            block
            outlined
            color="#1E88E5"
            class="costa-border"
            @click="openDrivingDirections"
          >
            <v-icon
              small
              class="pr-2"
              >fa-car</v-icon
            >
            {{ $i18n.t('driving_directions') }}
            <v-icon
              small
              class="pl-2"
              >fa-walking</v-icon
            >
          </v-btn>
        </v-col>
        <v-col
          v-if="mapCoords"
          cols="12"
          class="mt-3"
          style="overflow: hidden; border-radius: 8px"
          ref="mapContainer"
        >
          <Map
            v-if="renderMap && $store.state.googleMapsLoaded"
            :map-coords="mapCoords"
          />
        </v-col>

        <v-col
          :cols="enableCollapsing ? 10 : 12"
          :class="(enableCollapsing ? 'py-2' : 'pt-3 pb-1') + ' px-2'"
          @click="toggleRulesCollapsed"
        >
          <h3>{{ $t('conditions_title') }}</h3>
        </v-col>
        <v-col
          v-if="enableCollapsing"
          cols="2"
          class="feature-collapse-icon py-2 pr-2"
          @click="toggleRulesCollapsed"
        >
          <v-icon small>{{
            rulesCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'
          }}</v-icon>
        </v-col>

        <template v-if="!rulesCollapsed">
          <v-col
            cols="12"
            class="px-2 py-1"
          >
            <v-icon
              small
              class="condition-icon"
              >fa-clock</v-icon
            >
            {{ $i18n.t('condition_register_in') }}
          </v-col>
          <v-col
            cols="12"
            class="px-2 py-1"
          >
            <v-icon
              small
              class="condition-icon"
              >fa-clock</v-icon
            >
            {{ $i18n.t('condition_register_out') }}
          </v-col>
          <v-col
            cols="12"
            class="px-2 py-1"
          >
            <v-icon
              small
              class="condition-icon"
              >fa-key</v-icon
            >
            {{ $i18n.t('condition_keys') }}
          </v-col>
          <v-col
            cols="12"
            class="px-2 py-1"
          >
            <v-icon
              small
              class="condition-icon"
              >fa-moon</v-icon
            >
            {{ $i18n.t('condition_night_peace') }}
          </v-col>
          <v-col
            cols="12"
            class="px-2 py-1"
          >
            <v-icon
              small
              class="condition-icon"
              >fa-ban</v-icon
            >
            {{ $i18n.t('no_parties') }}
          </v-col>
          <v-col
            cols="12"
            class="px-2 py-1"
          >
            <v-icon
              small
              class="condition-icon"
              >fa-smoking-ban</v-icon
            >
            {{ $i18n.t('condition_smoking') }}
          </v-col>
        </template>
      </template>
      <v-bottom-navigation
        v-if="isMobileView"
        :value="true"
        fixed
        height="80px"
      >
        <v-container>
          <v-row>
            <v-col
              cols="6"
              :style="
                'padding: ' +
                (bookingNights >= 61 ? 20 : 5) +
                'px 15px; font-size: 12px; color: #219AC8; text-align: center;'
              "
            >
              <template v-if="bookingPeriod && bookingNights">
                {{ bookingPeriod }}
                <br />
                <span style="font-size: 18px; font-weight: 900">
                  {{ mobileBottomPriceText }}
                </span>
                <template v-if="!(bookingNights >= 26)">
                  <br />
                  {{ bookingNights }}
                  {{
                    parseInt(priceObject.bookingDays) === 1
                      ? $i18n.t('öö').toLowerCase()
                      : $i18n.t('ööd')
                  }}
                </template>
                <template v-if="displayPrice === '? '">
                  <br />
                  <span style="color: red"
                    ><b>{{ $i18n.t('dates_not_available_short') }}</b></span
                  >
                </template>
              </template>
              <div
                v-else
                class="pt-5"
                @click="scrollToCalendar"
              >
                <b>{{ $i18n.t('please_select_dates') }}</b>
              </div>
            </v-col>
            <v-col cols="6">
              <v-btn
                class="csr-large-text-btn elevation-1"
                :style="
                  (!(bookingPeriod && bookingNights) ? '' : '') +
                  'height: 35px; font-size: 16px;'
                "
                block
                @click="navigateToObjectBookingForm(object)"
              >
                {{ $t('broneeri_kohe') }}
              </v-btn>
              <div
                style="
                  color: #4caf50;
                  height: 22px;
                  text-align: center;
                  font-size: 11px;
                "
                class="pt-2"
              >
                <b>{{ $i18n.t('no_charges_yet') }}</b>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-bottom-navigation>
    </v-row>
  </v-container>
</template>

<script>
import Map from './Map'
import sharedComputed from '../../methods/sharedComputed'
import MainShare from '../App/Extras/_MainShare'
import sharedMethods from '../../methods/sharedMethods'
import ContactUsMenu from '../App/Menu/ContactUsMenu'
import ObjectInfoFeaturesForGroup from './ObjectInfoFeaturesForGroup'
import ObjectRoomFeatures from './ObjectRoomFeatures'
import MyLoader from '../App/_MyLoader'
import methods from '../../methods/methods'
// import ObjectPrice from './ObjectPrice'
import ObjectImages from '../ObjectImages/ObjectImages'
import { createHelpers } from 'vuex-map-fields'
import CalendarNavigation from '../Calendar/CalendarNavigation'
import CalendarLegend from '../Calendar/CalendarLegend'
import state from '../../store/state.js'
import moment from 'moment'
import helper from '@/methods/helper'
import sharedObjectComputed from '@/methods/sharedObjectComputed'
import objectMethods from '@/methods/objectMethods'

const descDefaultHeight = 96

const isFacebookApp = () => {
  const ua = navigator.userAgent || navigator.vendor || window.opera
  return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1
}

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ObjectInfo',

  data() {
    return {
      pricesCollapsed: false,
      rulesCollapsed: false,
      enableCollapsing: false,
      renderMap: false,
      descriptionHeight: descDefaultHeight,
      showReadMore: false,
    }
  },

  components: {
    ObjectImages,
    CalendarNavigation,
    MyLoader,
    ContactUsMenu,
    ObjectRoomFeatures,
    ObjectInfoFeaturesForGroup,
    MainShare,
    CalendarLegend,
    Map,
  },

  computed: {
    ...mapFields(Object.keys(state)),
    ...sharedComputed,
    ...sharedObjectComputed,

    mobileBottomPriceText() {
      if (this.priceObject.bookingDays >= 26) {
        const monthDays =
          this.priceObject.bookingDays < 30 ? this.priceObject.bookingDays : 30
        const monthPrice = Math.round(
          (this.priceObject.bookingPrice / this.priceObject.bookingDays) *
            monthDays
        )
        return monthPrice + '€ / ' + this.$i18n.t('month').toLowerCase()
      }
      return this.priceObject.bookingMinPeriodPrice
        ? this.rentalPrice + ' €'
        : '-'
    },

    containerStyle() {
      const style = {
        borderRadius: 0,
      }
      if (this.isMobileView && !isFacebookApp()) {
        style.paddingTop = '6px'
        style.marginTop = '48px'
      }
      return style
    },

    displayPrice() {
      if (
        this.priceObject.bookingPrice &&
        this.priceObject.bookingDays &&
        this.priceObject.bookingDays > 0 &&
        !this.loadingObjectInfo
      ) {
        return (
          parseInt(
            (this.priceObject.bookingPrice / this.priceObject.bookingDays) * 100
          ) / 100
        )
      }
      if (this.loadingObjectInfo) {
        return '... '
      }
      return '? ' // this.object.dayPrice || (Math.ceil(this.object.price / 7))
    },

    objectRoomsComputed() {
      if (!this.object || !this.object.objectRooms) {
        return []
      }
      return JSON.parse(JSON.stringify(this.object.objectRooms)).sort(
        (a, b) => {
          return parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
        }
      )
    },

    objectImagesComputed() {
      if (!this.object || !this.object.objectImages) {
        return []
      }
      return this.sortedObjectImages(this.object.objectImages)
    },

    objectPricesComputed() {
      if (!this.object || !this.object.prices) {
        return []
      }
      return JSON.parse(JSON.stringify(this.object.prices)).sort((a, b) => {
        return parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
      })
    },

    bookingPeriod() {
      moment.locale(this.lang)
      if (this.searchFilters.dateStart && this.searchFilters.dateEnd) {
        return (
          moment(this.formatYMD(this.searchFilters.dateStart)).format(
            'D. MMM'
          ) +
          ' - ' +
          moment(this.formatYMD(this.searchFilters.dateEnd)).format('D. MMM')
        )
      }
      return null
    },

    bookingNights() {
      if (this.searchFilters.dateStart && this.searchFilters.dateEnd) {
        return moment(this.formatYMD(this.searchFilters.dateEnd)).diff(
          moment(this.formatYMD(this.searchFilters.dateStart)),
          'days'
        )
      }
      return 0
    },

    objectFeatures() {
      if (!this.object.features) {
        return []
      }
      return Object.keys(this.object.features).map((id) => {
        const feature = this.object.features[id]
        feature.id = id
        return feature
      })
    },

    mapCoords() {
      const tmp = this.object.mapCoords && this.object.mapCoords.split(',')
      if (!tmp || !tmp[0] || !tmp[1]) {
        return false
      }
      return {
        lat: parseFloat(tmp[0].trim()),
        lng: parseFloat(tmp[1].trim()),
      }
    },

    objectInfoShort() {
      if (this.templateVarsByLang && this.templateVarsByLang[this.lang]) {
        return methods.replaceVars(
          this.object.propertiesShort,
          this.templateVarsByLang[this.lang]
        )
      }
      return null
    },

    objectInfoExtended() {
      if (this.templateVarsByLang && this.templateVarsByLang[this.lang]) {
        return methods.replaceVars(
          this.object.propertiesExtended,
          this.templateVarsByLang[this.lang]
        )
      }
      return null
    },
  },

  props: {
    object: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  created() {
    if (this.mobile) {
      this.rulesCollapsed = false
      this.pricesCollapsed = false
      this.enableCollapsing = false
    }
    this.setNavigationCalendarMonth()
    window.addEventListener('scroll', this.checkScrollPosition, {
      passive: true,
    })
  },

  destroyed() {
    window.removeEventListener('scroll', this.checkScrollPosition)
  },

  watch: {
    lang() {
      this.$nextTick(() => {
        this.setDescriptionHeight()
      })
    },
  },

  mounted() {
    this.renderMap = false
    this.$nextTick(() => {
      this.setDescriptionHeight()
    })
  },

  methods: {
    ...sharedMethods,
    ...objectMethods,

    checkScrollPosition() {
      const scrollPosition = window.scrollY + window.innerHeight
      const mapPosition = this.$refs.mapContainer.offsetTop
      if (scrollPosition >= mapPosition - 500) {
        this.renderMap = true
        window.removeEventListener('scroll', this.checkScrollPosition)
      }
    },

    setDescriptionHeight() {
      this.descriptionHeight = 108
      // console.log(this.$refs, 600, this.$refs?.descriptionContent)
      // console.log(this.$refs.descriptionContent?.clientHeight)
      // console.dir(this.$refs.descriptionContent?.scrollHeight)

      this.$nextTick(() => {
        if (
          this.$refs?.descriptionContent &&
          this.$refs.descriptionContent.clientHeight <
            this.$refs.descriptionContent.scrollHeight
        ) {
          this.descriptionHeight = descDefaultHeight
        } else {
          this.descriptionHeight = null
        }
      })
    },

    toggleReadMore() {
      if (this.descriptionHeight) {
        // this.descriptionHeight = this.$refs.descriptionContent.scrollHeight
        this.descriptionHeight = null
      } else {
        this.descriptionHeight = descDefaultHeight
      }
    },

    scrollToVideo() {
      this.$vuetify.goTo('#video', {
        duration: 700,
        easing: 'easeInOutCubic',
        offset: 0,
      })
    },

    openDrivingDirections() {
      window.open(
        'https://www.google.com/maps/dir/?api=1&destination=' +
          this.object.mapCoords,
        '_blank'
      )
      // window.open('https://www.google.com/maps/dir//' + this.object.address, '_blank')
    },

    scrollToCalendar() {
      this.$nextTick(() => {
        this.$vuetify.goTo('#object-calendar', {
          duration: 700,
          easing: 'easeInOutCubic',
          offset: 10,
        })
      })
    },

    setNavigationCalendarMonth() {
      if (!this.searchFilters.dateStart) {
        return
      }
      this.calendarMonth = moment(
        helper.dateToYMD(this.searchFilters.dateStart)
      ).format('MM')
      this.calendarYear = moment(
        helper.dateToYMD(this.searchFilters.dateStart)
      ).format('YYYY')
    },

    togglePricesCollapsed() {
      if (this.enableCollapsing) {
        this.pricesCollapsed = !this.pricesCollapsed
      }
    },

    toggleRulesCollapsed() {
      if (this.enableCollapsing) {
        this.rulesCollapsed = !this.rulesCollapsed
        this.$nextTick(() => {
          window.scrollTo(0, document.body.scrollHeight)
        })
      }
    },

    featuresFieldToUse(typeName) {
      if (typeName === 'bedroom') {
        typeName = 'livingroom'
      } // Share same type
      return typeName + 'Features'
    },

    hasPeriodPrices(pricePeriod) {
      if (!this.object.prices || this.object.prices.length === 0) {
        return false
      }
      return this.object.prices.filter((price) => price[pricePeriod]).length > 0
    },

    goBack() {
      window.history.back()
    },
  },
}
</script>

<style lang="scss">
.desc-content-cut {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.object-info {
  .v-btn.v-size--default {
    font-size: 1rem;
  }
}
</style>
